import { Status } from "src/api/Status";
import { ActiveInhabitant } from "src/api/Active";

// Utility functions for user status.
export const StatusUtil = {

    isStatusActive(status: Status): boolean {
        return status === ActiveInhabitant || status === 'active';
    },
}
